// src/stores/globalLoader.store.ts
import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useGlobalLoaderStore = defineStore("globalLoader", () => {
	const counter = ref(0);
	const isLoading = computed(() => counter.value > 0);

	function show() {
		counter.value++;
	}
	function hide() {
		if (counter.value > 0) counter.value--;
	}

	return { isLoading, show, hide };
});
